import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ContentLoader from 'react-content-loader'

export default class ConfigLoader extends Component {
  static propTypes = {
    withTabs: PropTypes.bool,
    compact: PropTypes.bool,
    withTitle: PropTypes.bool
  }

  static defaultProps = {
    withTabs: true,
    withTitle: false,
    compact: false
  }

  render() {
    const { withTabs, withTitle, compact } = this.props

    const baseY = withTabs || withTitle ? 20 : 0
    const substractXwidth = compact ? 40 : 0
    const substractXposition = compact ? 70 : 0

    return (
      <ContentLoader primaryColor="#f3f3f3" secondaryColor="#ecebeb">
        {withTabs && <rect x={0} y={0} rx="1" ry="1" width={50} height="10" />}
        {withTabs && <rect x={55} y={0} rx="1" ry="1" width={50} height="10" />}
        {withTabs &&
          <rect x={110} y={0} rx="1" ry="1" width={50} height="10" />}
        {withTabs &&
          <rect x={165} y={0} rx="1" ry="1" width={50} height="10" />}
        {withTabs &&
          <rect x={220} y={0} rx="1" ry="1" width={50} height="10" />}

        {withTitle && <rect x={0} y={0} rx="1" ry="1" width={70} height="10" />}

        <rect
          x="0"
          y={`${baseY + 0}`}
          rx="1"
          ry="1"
          width={`${130 - substractXwidth}`}
          height="8"
        />
        <rect
          x={`${185 - substractXposition}`}
          y={`${baseY + 0}`}
          rx="1"
          ry="1"
          width={50}
          height="8"
        />
        <rect
          x={`${245 - substractXposition}`}
          y={`${baseY + 0}`}
          rx="1"
          ry="1"
          width={10}
          height="8"
        />

        <rect
          x={0}
          y={`${baseY + 20}`}
          rx="1"
          ry="1"
          width={`${130 - substractXwidth}`}
          height="8"
        />
        <rect
          x={`${185 - substractXposition}`}
          y={`${baseY + 20}`}
          rx="1"
          ry="1"
          width={50}
          height="8"
        />
        <rect
          x={`${245 - substractXposition}`}
          y={`${baseY + 20}`}
          rx="1"
          ry="1"
          width={10}
          height="8"
        />

        <rect
          x={0}
          y={`${baseY + 40}`}
          rx="1"
          ry="1"
          width={`${130 - substractXwidth}`}
          height="8"
        />
        <rect
          x={`${185 - substractXposition}`}
          y={`${baseY + 40}`}
          rx="1"
          ry="1"
          width={50}
          height="8"
        />
        <rect
          x={`${245 - substractXposition}`}
          y={`${baseY + 40}`}
          rx="1"
          ry="1"
          width={10}
          height="8"
        />

        <rect
          x={0}
          y={`${baseY + 60}`}
          rx="1"
          ry="1"
          width={`${130 - substractXwidth}`}
          height="8"
        />
        <rect
          x={`${185 - substractXposition}`}
          y={`${baseY + 60}`}
          rx="1"
          ry="1"
          width={50}
          height="8"
        />
        <rect
          x={`${245 - substractXposition}`}
          y={`${baseY + 60}`}
          rx="1"
          ry="1"
          width={10}
          height="8"
        />

        <rect
          x={0}
          y={`${baseY + 80}`}
          rx="1"
          ry="1"
          width={`${130 - substractXwidth}`}
          height="8"
        />
        <rect
          x={`${185 - substractXposition}`}
          y={`${baseY + 80}`}
          rx="1"
          ry="1"
          width={50}
          height="8"
        />
        <rect
          x={`${245 - substractXposition}`}
          y={`${baseY + 80}`}
          rx="1"
          ry="1"
          width={10}
          height="8"
        />

        <rect
          x={0}
          y={`${baseY + 100}`}
          rx="1"
          ry="1"
          width={`${130 - substractXwidth}`}
          height="8"
        />
        <rect
          x={`${185 - substractXposition}`}
          y={`${baseY + 100}`}
          rx="1"
          ry="1"
          width={50}
          height="8"
        />
        <rect
          x={`${245 - substractXposition}`}
          y={`${baseY + 100}`}
          rx="1"
          ry="1"
          width={10}
          height="8"
        />
      </ContentLoader>
    )
  }
}
